<app-dialog-header
  [title]="isTicketTransition ? 'Virar este ingresso' : 'Virar para o próximo lote'"
  [disabled]="loading" />

<mat-dialog-content class="batch-transition-modal__content">
  <div class="batch-transition-modal__shell">
    @if (isTicketTransition) {
      <p class="batch-transition-modal__message">
        Você está prestes a encerrar
        <strong>{{ data.ticketTitle || "este ingresso" }}</strong>
        neste lote e abrir o correspondente no lote {{ data.nextBatchNumber }}.
        Os demais tipos deste lote continuam à venda.
      </p>
    } @else {
      <p class="batch-transition-modal__message">
        Você está prestes a encerrar o lote atual e avançar para o lote {{ data.nextBatchNumber }}.
      </p>
    }
    <p class="batch-transition-modal__warning">
      <strong>Esta ação é irreversível. Após confirmar, não será possível voltar ao lote anterior.</strong>
    </p>
    @if (errorMessage) {
      <p role="alert" class="batch-transition-modal__feedback text-danger">{{ errorMessage }}</p>
    }
    @if (loading) {
      <p role="status" aria-live="polite" class="batch-transition-modal__feedback">
        {{ isTicketTransition ? "Virando ingresso. Aguarde a confirmação." : "Virando lote. Aguarde a confirmação." }}
      </p>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="batch-transition-modal__actions">
  <app-button styleType="outlined" [disabled]="loading" (btnClick)="cancel()">Cancelar</app-button>
  <app-button data-testid="confirm-transition" [disabled]="loading" [loading]="loading" (btnClick)="confirm()">
    Confirmar virada
  </app-button>
</mat-dialog-actions>
